let AdobeAn;
let exportRoot;
import createjs from 'createjs';
/* eslint-disable camelcase */
(function(cjs, an) {
    let p; // shortcut to reference prototypes
    const lib = {};
    const ss = {};
    const img = {};
    lib.ssMetadata = [];

    // symbols:
    // helper functions:

    function mc_symbol_clone() {
        const clone = this._cloneProps(new this.constructor(this.mode, this.startPosition, this.loop));
        clone.gotoAndStop(this.currentFrame);
        clone.paused = this.paused;
        clone.framerate = this.framerate;
        return clone;
    }

    function getMCSymbolPrototype(symbol, nominalBounds, frameBounds) {
        const prototype = cjs.extend(symbol, cjs.MovieClip);
        prototype.clone = mc_symbol_clone;
        prototype.nominalBounds = nominalBounds;
        prototype.frameBounds = frameBounds;
        return prototype;
    }

    (lib.Symbol2 = function(mode, startPosition, loop) {
        this.initialize(mode, startPosition, loop, {});

        // Layer_1
        this.shape = new cjs.Shape();
        this.shape.graphics
            .f('#FFFE9B')
            .s()
            .p('AAkAhQgrgDghAWIgLgOIgWgbQgogwgdgeQAqgXAzAKQAwAKAkAnIABAAIBrBzQgugvg9gEg');
        this.shape.setTransform(1, -34.2);

        this.shape_1 = new cjs.Shape();
        this.shape_1.graphics
            .f('#FFCC68')
            .s()
            .p('AgtEOIAAmYIBYBfIAEAFIAGAHIACABIAAAAQARARAUALIAAGkgAhblqQAJgRAKgLQAOgQAUgLQAdAfAnAxIAWAbIALANQgPAKgNAOQgMANgIAOg');
        this.shape_1.setTransform(-9.4, 0.8);

        this.shape_2 = new cjs.Shape();
        this.shape_2.graphics
            .f('#DC9A68')
            .s()
            .p('AgKBAIgSgTIAAgBQglgqgJg4QgGgqAMgkIAAAAQAEgOAHgNIBrB0QgWAmACAxQAEBCArAyg');
        this.shape_2.setTransform(-12.9, -19.5);

        this.shape_3 = new cjs.Shape();
        this.shape_3.graphics
            .f('#B9C4E3')
            .s()
            .p('AAAAAIABABIAAAAg');
        this.shape_3.setTransform(-4, -2.3);

        this.shape_4 = new cjs.Shape();
        this.shape_4.graphics
            .f('#DE7D21')
            .s()
            .p('Ag3g0QgUgLgRgRIgCgCIgGgHIgEgEQgrgygEhCQgDgyAWgmQAIgOAMgNQANgOAPgKQAhgVAsADQA8ADAuAwIADADQAvA0ADBFIAAAVIAAIWIjPADg');
        this.shape_4.setTransform(5.4, 5.9);

        this.shape_5 = new cjs.Shape();
        this.shape_5.graphics
            .f('#E7E7E7')
            .s()
            .p('AAAAAIAAAAIAAAAg');
        this.shape_5.setTransform(-19.8, -32.8);

        this.timeline.addTween(
            cjs.Tween.get({})
                .to({state: [{t: this.shape_5}, {t: this.shape_4}, {t: this.shape_3}, {t: this.shape_2}, {t: this.shape_1}, {t: this.shape}]})
                .wait(1)
        );
    }).prototype = getMCSymbolPrototype(lib.Symbol2, new cjs.Rectangle(-20.6, -42.6, 41.2, 85.2), null);

    (lib.Symbol1 = function(mode, startPosition, loop) {
        this.initialize(mode, startPosition, loop, {});

        // Layer_1
        this.instance = new lib.Symbol2();
        this.instance.parent = this;
        this.instance.setTransform(9.6, 35.9, 1, 1, 0, 0, 0, 9.6, 35.9);

        this.timeline.addTween(
            cjs.Tween.get(this.instance)
                .to({regX: 8.9, regY: 36, scaleX: 0.79, scaleY: 1.13, skewX: -40.1, skewY: -25.4, x: 9.7, y: 36.1}, 6, cjs.Ease.quadInOut)
                .wait(1)
                .to({regX: 0, regY: 0, scaleX: 0.8, scaleY: 1.12, skewX: -38.3, skewY: -24.3, x: -21.9, y: 7.2}, 0)
                .wait(1)
                .to({scaleX: 0.82, scaleY: 1.11, skewX: -33.3, skewY: -21.1, x: -19.1, y: 5.3}, 0)
                .wait(1)
                .to({scaleX: 0.87, scaleY: 1.08, skewX: -24.5, skewY: -15.6, x: -14, y: 2.7}, 0)
                .wait(1)
                .to({scaleX: 0.92, scaleY: 1.05, skewX: -14.3, skewY: -9.1, x: -7.8, y: 0.8}, 0)
                .wait(1)
                .to({scaleX: 0.97, scaleY: 1.02, skewX: -6.2, skewY: -4, x: -3, y: 0.1}, 0)
                .wait(1)
                .to({regX: 8.8, regY: 36, scaleX: 0.99, scaleY: 1, skewX: -1.5, skewY: -1, x: 9.5, y: 36}, 0)
                .wait(1)
        );
    }).prototype = p = new cjs.MovieClip();
    p.nominalBounds = new cjs.Rectangle(-20.6, -42.6, 41.2, 85.2);

    // stage content:
    (lib._11 = function(mode, startPosition, loop) {
        this.initialize(mode, startPosition, loop, {});

        // Layer_3
        this.instance = new lib.Symbol1();
        this.instance.parent = this;
        this.instance.setTransform(128.8, 115.1, 1.078, 0.994, 0, 0, -30, 0.4, 0.4);

        this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

        // Isolation Mode
        this.shape = new cjs.Shape();
        this.shape.graphics
            .f('#DC9A68')
            .s()
            .p('AhWgTIADgJICqAwIgEAJg');
        this.shape.setTransform(41.2, 79.7);

        this.shape_1 = new cjs.Shape();
        this.shape_1.graphics
            .f('#DC9A68')
            .s()
            .p('AhKgrIAGgIICPBfIgGAIg');
        this.shape_1.setTransform(43.9, 74.4);

        this.shape_2 = new cjs.Shape();
        this.shape_2.graphics
            .f('#DC9A68')
            .s()
            .p('AhQgkIAFgJICcBRIgFAJg');
        this.shape_2.setTransform(71.9, 92.9);

        this.shape_3 = new cjs.Shape();
        this.shape_3.graphics
            .f('#DC9A68')
            .s()
            .p('AhVgJIACgKICpAdIgCAKg');
        this.shape_3.setTransform(73.6, 87.2);

        this.shape_4 = new cjs.Shape();
        this.shape_4.graphics
            .f('#FFCC68')
            .s()
            .p('AgHCiQg8gfgohFQgnhEADhDQADhDAtgaQAsgZA7AeQA8AfAoBFQAoBEgEBDQgEBDgsAZQgUAMgYAAQgcAAgfgQg');
        this.shape_4.setTransform(15, 143.2);

        this.shape_5 = new cjs.Shape();
        this.shape_5.graphics
            .f('#DE7D21')
            .s()
            .p('AglhIIBqASIgbA/IhuBAg');
        this.shape_5.setTransform(30.8, 153);

        this.shape_6 = new cjs.Shape();
        this.shape_6.graphics
            .f('#FFFE9A')
            .s()
            .p('AhaghIBng8IBOASIgjCpg');
        this.shape_6.setTransform(14.5, 130);

        this.shape_7 = new cjs.Shape();
        this.shape_7.graphics
            .f('#DE7D21')
            .s()
            .p('AgYBYQg3gZgpg9QAPgJAQADQARADAPgIIBfg2IBAglQAZA9gIA0QgJA2gmAWQgUAMgXAAQgZAAgcgNg');
        this.shape_7.setTransform(27.5, 145.1);

        this.shape_8 = new cjs.Shape();
        this.shape_8.graphics
            .f('#DC9A68')
            .s()
            .p('AhrBMQgLgTgHgQIAegQQASgMBDgxQAygmAjgSQASAUAOAZQAKARAIAVIgxAcIhSAuQgOAHggAGQgdAGgQAJg');
        this.shape_8.setTransform(25.2, 136);

        this.shape_9 = new cjs.Shape();
        this.shape_9.graphics
            .f('#FFFE9A')
            .s()
            .p('AhrgNQAIg3AmgWQAkgVAvARQAvARApAuQgjATgzAlQhCAxgTAMIgdAQQgZg9AIg2g');
        this.shape_9.setTransform(21.7, 129.8);

        this.shape_10 = new cjs.Shape();
        this.shape_10.graphics
            .f('#E7E7E7')
            .s()
            .p('Ai/gEIC6hqIDEBzIi5Bqg');
        this.shape_10.setTransform(19.8, 137.8);

        this.shape_11 = new cjs.Shape();
        this.shape_11.graphics
            .f('#FFFE9A')
            .s()
            .p('AAAA1QgSgLgNgXQgOgWAAgWQAAgWAOgIQANgIASALQATAMANAXQAOAWAAAWQAAAWgOAHQgFADgGAAQgKAAgLgGg');
        this.shape_11.setTransform(57.3, 83.6);

        this.shape_12 = new cjs.Shape();
        this.shape_12.graphics
            .f('#DC9A68')
            .s()
            .p('AgIgCIAIgHIAJAKIgPAJg');
        this.shape_12.setTransform(61.2, 88.2);

        this.shape_13 = new cjs.Shape();
        this.shape_13.graphics
            .f('#DC9A68')
            .s()
            .p('AgKAAIAOgHIAHAGIAAAJg');
        this.shape_13.setTransform(55.2, 78);

        this.shape_14 = new cjs.Shape();
        this.shape_14.graphics
            .f('#DC9A68')
            .s()
            .p('AAAA1QgSgLgNgXQgOgWAAgWQAAgWAOgIQANgIASALQATAMANAXQAOAWAAAWQAAAVgOAIQgFADgGAAQgJAAgMgGg');
        this.shape_14.setTransform(58.9, 82.7);

        this.shape_15 = new cjs.Shape();
        this.shape_15.graphics
            .f('#DE7D21')
            .s()
            .p('AhhhcIDDBIIjDBwg');
        this.shape_15.setTransform(102.5, 55);

        this.shape_16 = new cjs.Shape();
        this.shape_16.graphics
            .f('#FFCC68')
            .s()
            .p('AhygnIDlg1IAAC4g');
        this.shape_16.setTransform(81.3, 55);

        this.shape_17 = new cjs.Shape();
        this.shape_17.graphics
            .f('#DE7D21')
            .s()
            .p('AhsiaIC9BLIAcDqg');
        this.shape_17.setTransform(43, 26.3);

        this.shape_18 = new cjs.Shape();
        this.shape_18.graphics
            .f('#FFCC68')
            .s()
            .p('AhsAdIAAi3IDZE1g');
        this.shape_18.setTransform(43, 26.3);

        this.shape_19 = new cjs.Shape();
        this.shape_19.graphics
            .f('#FFFE9A')
            .s()
            .p('AoogeIHzkgIJeFdInzEgg');
        this.shape_19.setTransform(87.4, 32.4);

        this.shape_20 = new cjs.Shape();
        this.shape_20.graphics
            .f('#DC9A68')
            .s()
            .p('AkujNIHykgIBrJ9IpdFeg');
        this.shape_20.setTransform(123.1, 84.9);

        this.shape_21 = new cjs.Shape();
        this.shape_21.graphics
            .f('#FFCC68')
            .s()
            .p('AkuCvIAAq7IJdFeIAAK7g');
        this.shape_21.setTransform(62.4, 81.8);

        this.shape_22 = new cjs.Shape();
        this.shape_22.graphics
            .f('#FFFE9A')
            .s()
            .p('Ai3AhIDsiLICDBKIjsCLg');
        this.shape_22.setTransform(111.2, 221.3);

        this.shape_23 = new cjs.Shape();
        this.shape_23.graphics
            .f('#DE7D21')
            .s()
            .p('Ah2ARIDtiLIAABqIjtCLg');
        this.shape_23.setTransform(117.7, 230.3);

        this.shape_24 = new cjs.Shape();
        this.shape_24.graphics
            .f('#FFCC68')
            .s()
            .p('AhBAQIAAhpICDBKIAABpg');
        this.shape_24.setTransform(99.3, 233.6);

        this.shape_25 = new cjs.Shape();
        this.shape_25.graphics
            .f('#FFFE9A')
            .s()
            .p('AjzBFIFkjTICDBKIlkDTg');
        this.shape_25.setTransform(140.9, 175.5);

        this.shape_26 = new cjs.Shape();
        this.shape_26.graphics
            .f('#DE7D21')
            .s()
            .p('AiyhXIFljUIAAGEIllDTg');
        this.shape_26.setTransform(147.5, 198.6);

        this.shape_27 = new cjs.Shape();
        this.shape_27.graphics
            .f('#FFCC68')
            .s()
            .p('AhBCeIAAmEICDBKIAAGDg');
        this.shape_27.setTransform(123, 205.5);

        this.shape_28 = new cjs.Shape();
        this.shape_28.graphics
            .f('#FFFE9A')
            .s()
            .p('ArVAAILVmiILWGiIrWGjg');
        this.shape_28.setTransform(92.7, 99.4);

        this.shape_29 = new cjs.Shape();
        this.shape_29.graphics
            .f('#DC9A68')
            .s()
            .p('AlqkCILVmkIAAOqIrVGjg');
        this.shape_29.setTransform(129.1, 167.3);

        this.shape_30 = new cjs.Shape();
        this.shape_30.graphics
            .f('#FFCC68')
            .s()
            .p('AlqEEIAAuqILVGkIAAOpg');
        this.shape_30.setTransform(56.4, 167.3);

        this.shape_31 = new cjs.Shape();
        this.shape_31.graphics
            .f()
            .s('#000000')
            .ss(3)
            .p(
                'AKzkoIheozIpeleIk0CyIi/hLIAAMxIh4BFIAADKQgXAAgTAKIgBAAIhoA7QgYAOgNAdQgMAcABAkIAAAAQAAAEABAFQADA4AhA5QAeA0AsAfQArAfApABIAAFDILVGjIABAAICDBKIDtiMIAAAAIFmjTIAAw4g'
            );
        this.shape_31.setTransform(83, 121.5);

        this.timeline.addTween(
            cjs.Tween.get({})
                .to({
                    state: [
                        {t: this.shape_31},
                        {t: this.shape_30},
                        {t: this.shape_29},
                        {t: this.shape_28},
                        {t: this.shape_27},
                        {t: this.shape_26},
                        {t: this.shape_25},
                        {t: this.shape_24},
                        {t: this.shape_23},
                        {t: this.shape_22},
                        {t: this.shape_21},
                        {t: this.shape_20},
                        {t: this.shape_19},
                        {t: this.shape_18},
                        {t: this.shape_17},
                        {t: this.shape_16},
                        {t: this.shape_15},
                        {t: this.shape_14},
                        {t: this.shape_13},
                        {t: this.shape_12},
                        {t: this.shape_11},
                        {t: this.shape_10},
                        {t: this.shape_9},
                        {t: this.shape_8},
                        {t: this.shape_7},
                        {t: this.shape_6},
                        {t: this.shape_5},
                        {t: this.shape_4},
                        {t: this.shape_3},
                        {t: this.shape_2},
                        {t: this.shape_1},
                        {t: this.shape}
                    ]
                })
                .wait(1)
        );
    }).prototype = p = new cjs.MovieClip();
    p.nominalBounds = new cjs.Rectangle(84.7, 121.7, 168.7, 245.6);
    // library properties:
    lib.properties = {
        id: '5808781A11414157AB490F32B311FE45',
        width: 173,
        height: 246,
        fps: 24,
        color: '#CCCCCC',
        opacity: 0.0,
        manifest: [],
        preloads: []
    };

    // bootstrap callback support:

    (lib.Stage = function(canvas) {
        createjs.Stage.call(this, canvas);
    }).prototype = p = new createjs.Stage();

    p.setAutoPlay = function(autoPlay) {
        this.tickEnabled = autoPlay;
    };
    p.play = function() {
        this.tickEnabled = true;
        this.getChildAt(0).gotoAndPlay(this.getTimelinePosition());
    };
    p.stop = function(ms) {
        if (ms) this.seek(ms);
        this.tickEnabled = false;
    };
    p.seek = function(ms) {
        this.tickEnabled = true;
        this.getChildAt(0).gotoAndStop((lib.properties.fps * ms) / 1000);
    };
    p.getDuration = function() {
        return (this.getChildAt(0).totalFrames / lib.properties.fps) * 1000;
    };

    p.getTimelinePosition = function() {
        return (this.getChildAt(0).currentFrame / lib.properties.fps) * 1000;
    };

    an.bootcompsLoaded = an.bootcompsLoaded || [];
    if (!an.bootstrapListeners) {
        an.bootstrapListeners = [];
    }

    an.bootstrapCallback = function(fnCallback) {
        an.bootstrapListeners.push(fnCallback);
        if (an.bootcompsLoaded.length > 0) {
            for (let i = 0; i < an.bootcompsLoaded.length; ++i) {
                fnCallback(an.bootcompsLoaded[i]);
            }
        }
    };

    an.compositions = an.compositions || {};
    an.compositions['5808781A11414157AB490F32B311FE45'] = {
        getStage: function() {
            return exportRoot.getStage();
        },
        getLibrary: function() {
            return lib;
        },
        getSpriteSheet: function() {
            return ss;
        },
        getImages: function() {
            return img;
        }
    };

    an.compositionLoaded = function(id) {
        an.bootcompsLoaded.push(id);
        for (let j = 0; j < an.bootstrapListeners.length; j++) {
            an.bootstrapListeners[j](id);
        }
    };

    an.getComposition = function(id) {
        return an.compositions[id];
    };
})((createjs = createjs || {}), (AdobeAn = AdobeAn || {}));

const composition = AdobeAn.getComposition('5808781A11414157AB490F32B311FE45');

export {AdobeAn};
export {composition};
